import React from 'react';

const Ex1_Training = () => {
    return (
        <div>Ex1_Training Component</div>
    );
}

export default Ex1_Training;
